import React from 'react';
import * as Yup from 'yup';
import { reach } from 'yup';

// Διαβάζει απο το Shape αν ένα πεδίο είναι required
export function useIsFieldRequiredHook(rootSchema: any) {
  const getIn = (obj: any, path: string) =>
    path.split('.').reduce((o, k) => (o == null ? o : o[k]), obj);

  const getParent = (values: any, path: string) => {
    const parts = path.split('.');
    (parts as any).pop();
    return parts.length ? getIn(values, parts.join('.')) : values;
  };

  const isRequired = React.useCallback(
    (path: string, values: any) => {
      // // const tests = formShape?.fields[fieldPath]?.tests;
      // // console.log('$$$ $$$', fieldPath, tests, formShape?.fields[fieldPath]);
      // // if (!tests) return false;
      // // return !!tests.find((test) => test?.OPTIONS?.name === 'required');

      // const fieldSchema = reach(rootSchema, path) as Yup.Schema<any>;
      // const parentPath = path.split('.').slice(0, -1).join('.');
      // const parent = parentPath ? parentPath.split('.').reduce((o, k) => o?.[k], values) : values;

      // try {
      //   // strict: true avoids defaults/casting that could mask “required”
      //   fieldSchema.validateSync(undefined, {
      //     context: values,
      //     strict: true,
      //     abortEarly: true,
      //     // parent,
      //   });
      //   // If undefined passes, it’s not required
      //   return false;
      // } catch (err: any) {
      //   // Yup sets .type === 'required' when it’s the required rule
      //   return err?.type === 'required';
      // }
      if (!rootSchema) return false;
      let fieldSchema: Yup.Schema<any>;
      try {
        fieldSchema = reach(rootSchema, path) as Yup.Schema<any>;
      } catch {
        return false;
      }
      if (!fieldSchema || !(fieldSchema as any).resolve) return false;

      // Resolve conditions with the current values
      const resolved = (fieldSchema as any).resolve({
        context: values,
        parent: getParent(values, path),
        value: getIn(values, path),
      });

      // Describe lists active tests; “required” shows up when it applies
      const desc = resolved.describe();
      return (desc.tests || []).some((t) => t.name === 'required');
    },
    [rootSchema]
  );
  return isRequired;
}

